const ERROR_CODES = Object.freeze({
  // Conversation-related errors
  CONVERSATION_DELETED: 'NFGRC001',
  // Subscription-related errors
  NO_ACTIVE_PLAN: 'NFGRC004',
  PLAN_LIMIT_REACHED: 'NFGRC005',
  TIME_LIMIT_EXCEEDED: 'NFGRC006',
});

export default ERROR_CODES;
